// extracted by mini-css-extract-plugin
export default {"imageWrapper":"bN-z","twoColumnImage":"cN-z"};